import React, { memo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { InformativePage } from './InformativePage';
import { redirectToPersonalInfo } from '../../store/dataCapture';

const InformativeScreen = memo(function InformativeScreen({ redirectToPersonalInfo }) {
  return <InformativePage onContinue={redirectToPersonalInfo} />;
});

const actionCreators = {
  redirectToPersonalInfo
};

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(null, mapDispatchToProps)(InformativeScreen);
